function w(o) {
  var t = o.align, r = o.alignVertical, e = o.textRotation, d = o.indent, i = o.wrap, n = o.fontFamily, f = o.fontSize, a = o.fontWeight, B = o.fontStyle, l = o.color, S = o.backgroundColor, y = o.borderColor, g = o.borderStyle, C = o.leftBorderColor, b = o.leftBorderStyle, p = o.rightBorderColor, m = o.rightBorderStyle, h = o.topBorderColor, u = o.topBorderStyle, x = o.bottomBorderColor, s = o.bottomBorderStyle;
  if (t || r || e || d || i || n || f || a || B || l || S || y || g || C || b || p || m || h || u || x || s)
    return v({
      align: t,
      alignVertical: r,
      textRotation: e,
      indent: d,
      wrap: i,
      fontFamily: n,
      fontSize: f,
      fontWeight: a,
      fontStyle: B,
      color: l,
      backgroundColor: S,
      borderColor: y,
      borderStyle: g,
      leftBorderColor: C,
      leftBorderStyle: b,
      rightBorderColor: p,
      rightBorderStyle: m,
      topBorderColor: h,
      topBorderStyle: u,
      bottomBorderColor: x,
      bottomBorderStyle: s
    });
}
function v(o) {
  var t = {};
  for (var r in o)
    o[r] !== void 0 && (t[r] = o[r]);
  return t;
}
export {
  w as default
};
//# sourceMappingURL=index.es299.js.map
